<template>
    <span>
        <input v-model="simpleFieldModel" type="hidden" :required="required" />
    </span>
</template>

<script>
import { mapGetters } from 'vuex';
import { SimpleFieldMixin } from '@/mixins/SimpleFieldMixin';

export default {
    components: {},
    mixins: [SimpleFieldMixin],
    computed: {
        ...mapGetters(['getProp'])
    },
    props: {}
};
</script>
